(function () {
  function closeItem(item) {
    var trigger = item.querySelector('[data-beato-program-faq-trigger]');
    var panel = item.querySelector('[data-beato-program-faq-panel]');

    if (!trigger || !panel) return;

    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }

  function openItem(item) {
    var trigger = item.querySelector('[data-beato-program-faq-trigger]');
    var panel = item.querySelector('[data-beato-program-faq-panel]');

    if (!trigger || !panel) return;

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }

  function initBeatoProgramFaq(root) {
    var scope = root || document;
    var accordions = scope.querySelectorAll('[data-beato-program-faq-accordion]');

    accordions.forEach(function (accordion) {
      if (accordion.dataset.initialized === 'true') return;
      accordion.dataset.initialized = 'true';

      accordion.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-beato-program-faq-trigger]');
        if (!trigger || !accordion.contains(trigger)) return;

        var item = trigger.closest('[data-beato-program-faq-item]');
        if (!item) return;

        var isOpen = item.classList.contains('is-open');
        var items = accordion.querySelectorAll('[data-beato-program-faq-item]');

        items.forEach(function (otherItem) {
          closeItem(otherItem);
        });

        if (!isOpen) {
          openItem(item);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBeatoProgramFaq(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initBeatoProgramFaq(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initBeatoProgramFaq(event.target);
  });
})();